<div *ngIf="!loader ; else loading">
  <div
    class="container"
    *ngIf="quoteDetails$ | async as quoteDetails; else loading"
  >
    <div class="row">
      <div class="col-md-3">
        <div (click)="navigateToDetails()" class="details-link">
          <i class="material-icons back-icon">keyboard_arrow_left</i
          ><span class="back-text">{{ "quoteTracking.backQuoteDetails" | cxTranslate }} </span>
        </div>
      </div>
      <div class="col-md-6 middle-text">
        <div>
          {{ "quoteTracking.acceptOrReject" | cxTranslate }}
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-10">
            <div class="row merge-quote-row">
              <div class="vs-card active">
                <div class="row" *ngIf="status">
                      <div class="col-md-3">
                        <div>{{ "quoteTracking.hashQuote" | cxTranslate }}</div>
                        <div class="quote-number">
                          {{ quoteDetails?.quoteDetailsList?.quoteId }}
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div>{{ "quoteTracking.quoteTotal" | cxTranslate }}</div>
                        <div class="bold">
                          {{ quoteDetails?.quoteDetailsList?.quoteTotal }}
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div>{{ "quoteTracking.quoteCreated1" | cxTranslate }}</div>
                        <div class="bold">
                          {{
                            quoteDetails?.quoteDetailsList?.createdDate
                              | date: "d MMM, yyyy"
                          }}
                        </div>
                      </div>

                      <div class="col-md-3 padding-left-right-none">
                        <div>{{ "quoteTracking.customerReference" | cxTranslate }}</div>
                        <div class="bold">
                          {{ quoteDetails?.quoteDetailsList?.quoteReference }}
                        </div>
                      </div>
                  <!-- <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <button
                          class="vs-primary-btn"
                          (click)="acceptEntireQuote()"
                        >
                          <i class="material-icons btn-icon">shopping_cart</i>
                          ACCEPT ENTIRE QUOTE
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button
                          class="vs-primary-btn"
                          (click)="openRejectPopUp()"
                        >
                          <i class="material-icons btn-icon">thumb_down</i>
                          REJECT ENTIRE QUOTE
                        </button>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="row" *ngIf="!status">
                  <div class="col-md-3">
                    <div>{{ "quoteTracking.hashQuote" | cxTranslate }}</div>
                    <div class="quote-number">
                      {{ quoteDetails?.quoteDetailsList?.quoteId }}
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div>{{ "quoteTracking.quoteTotal" | cxTranslate }}</div>
                    <div class="bold">
                      {{ quoteDetails?.quoteDetailsList?.quoteTotal }}
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div>{{ "quoteTracking.quoteCreated1" | cxTranslate }}</div>
                    <div class="bold">
                      {{
                        quoteDetails?.quoteDetailsList?.createdDate
                          | date: "d MMM, yyyy"
                      }}
                    </div>
                  </div>

                  <div class="col-md-3 padding-left-right-none">
                    <div>{{ "quoteTracking.quoteReference" | cxTranslate }}</div>
                    <div class="bold">
                      {{ quoteDetails?.quoteDetailsList?.quoteReference }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-10 align-center">
        <vs-merge-quote-products-list
          [addresses]="quoteDetails?.addressDetails"
          [quote]="quoteDetails?.quoteDetailsList"
          [acceptance]="acceptance"
          [quoteAcceptanceType]="quoteAcceptanceType"
          [dateObject]="dateObject"
        ></vs-merge-quote-products-list>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
